module.exports = __webpack_public_path__ + "components/flag/static/square/um-4e47fc8526c33789d92dcef4f5c5111a.svg";